/* Great Bharat Electronics — V4 cart display synchronisation. */
(function () {
  'use strict';

  function setText(node, text) { if (node.textContent !== text) node.textContent = text; }

  function getRoot() {
    return document.querySelector('.gbe-cart-page');
  }

  function formatMoney(cents) {
    var value = Number(cents);
    if (!Number.isFinite(value)) value = 0;

    if (typeof Number.prototype.toCurrency === 'function') return value.toCurrency();

    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'INR';

    try {
      if (currency === 'INR') {
        return 'Rs. ' + new Intl.NumberFormat('en-IN', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value / 100);
      }

      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(value / 100);
    } catch (error) {
      return (value / 100).toFixed(2);
    }
  }

  function localizedCartText(key, count, fallback) {
    var root = getRoot();
    var holder = root && root.querySelector('[data-gbe-cart-copy]');
    var text = '';
    if (holder) {
      try { text = JSON.parse(holder.textContent)[key] || ''; } catch (error) { text = ''; }
    }
    if (!text) text = typeof window.gbeTranslateV6 === 'function' ? window.gbeTranslateV6(fallback) : fallback;
    return String(text).split('__GBE_CART_COUNT__').join(String(count));
  }

  function itemLabel(count) {
    return localizedCartText(count === 1 ? 'itemOne' : 'itemOther', count, count + (count === 1 ? ' item' : ' items'));
  }

  function syncCartPresentation(detail) {
    var root = getRoot();
    if (!root || !detail) return;

    var total = Number(detail.total_price);
    if (Number.isFinite(total)) {
      root.querySelectorAll('[data-gbe-cart-total]').forEach(function (node) {
        setText(node, formatMoney(total));
      });

      root.querySelectorAll('[data-gbe-cod-total]').forEach(function (node) {
        var fee = Number(node.getAttribute('data-gbe-cod-fee'));
        if (!Number.isFinite(fee)) fee = 19900;
        setText(node, formatMoney(total + fee));
      });
    }

    var count = Number(detail.item_count);
    if (Number.isFinite(count)) {
      root.querySelectorAll('[data-gbe-cart-count]').forEach(function (node) {
        setText(node, itemLabel(count));
      });

      root.querySelectorAll('[data-gbe-cart-ready-count]').forEach(function (node) {
        setText(node, count > 0
          ? localizedCartText(count === 1 ? 'readyOne' : 'readyOther', count, count + (count === 1 ? ' item' : ' items') + ' ready for review.')
          : localizedCartText('empty', count, 'Add the TV part you need, then review your cart before checkout.'));
      });

      root.querySelectorAll('[data-gbe-cart-header-continue]').forEach(function (link) {
        if (link.hidden !== (count < 1)) link.hidden = count < 1;
      });
    }
  }

  document.addEventListener('cart-change', function (event) {
    syncCartPresentation(event.detail || {});
  });

  document.addEventListener('shopify:section:load', function () {
    var root = getRoot();
    if (!root) return;

    var wrapper = root.querySelector('.gbe-cart-wrapper');
    var status = wrapper ? Number(wrapper.getAttribute('data-status')) : NaN;
    if (Number.isFinite(status)) syncCartPresentation({ item_count: status });
  });
})();

/* Cart-only guard. Eligibility is rendered from the PAY COD app's own
   product and collection configuration. PAY COD remains the checkout authority. */
(function () {
  'use strict';

  var scheduled = false;

  function setAttribute(node, name, value) {
    if (node.getAttribute(name) !== String(value)) node.setAttribute(name, String(value));
  }

  function setClass(node, name, active) {
    if (node.classList.contains(name) !== active) node.classList.toggle(name, active);
  }

  function setHidden(node, hidden) {
    if (node.hidden !== hidden) node.hidden = hidden;
  }

  function setDisplay(node, value, priority) {
    if (node.style.getPropertyValue('display') !== value || node.style.getPropertyPriority('display') !== priority) {
      if (value) node.style.setProperty('display', value, priority);
      else node.style.removeProperty('display');
    }
  }

  function getPanel() {
    return document.querySelector('.gbe-paycod-panel--cart[data-gbe-paycod-panel]');
  }

  function catalogAllowsCod(panel) {
    var items = Array.prototype.slice.call(
      document.querySelectorAll('.gbe-cart-item[data-gbe-paycod-item-eligible]')
    );
    var allowed = items.length
      ? !items.some(function (item) {
          return item.getAttribute('data-gbe-paycod-item-eligible') === 'false';
        })
      : panel.getAttribute('data-gbe-catalog-cod-allowed') !== 'false';

    setAttribute(panel, 'data-gbe-catalog-cod-allowed', allowed ? 'true' : 'false');
    return allowed;
  }

  function remember(node) {
    if (node.dataset.gbeCartGuardStored === 'true') return;
    node.dataset.gbeCartGuardStored = 'true';
    node.dataset.gbeCartGuardHidden = node.hidden ? 'true' : 'false';
    node.dataset.gbeCartGuardAria = node.hasAttribute('aria-hidden')
      ? node.getAttribute('aria-hidden')
      : '__none__';
    node.dataset.gbeCartGuardTab = node.hasAttribute('tabindex')
      ? node.getAttribute('tabindex')
      : '__none__';
    node.dataset.gbeCartGuardDisplay = node.style.getPropertyValue('display') || '__none__';
    node.dataset.gbeCartGuardPriority = node.style.getPropertyPriority('display') || '__none__';
  }

  function restoreAttribute(node, name, value) {
    if (value === '__none__' || value === undefined) {
      if (node.hasAttribute(name)) node.removeAttribute(name);
    } else setAttribute(node, name, value);
  }

  function suppress(node, active) {
    if (active) {
      remember(node);
      setClass(node, 'gbe-cart-paycod-suppressed', true);
      setHidden(node, true);
      setAttribute(node, 'aria-hidden', 'true');
      setAttribute(node, 'tabindex', '-1');
      setDisplay(node, 'none', 'important');
      return;
    }

    if (node.dataset.gbeCartGuardStored !== 'true') return;

    setClass(node, 'gbe-cart-paycod-suppressed', false);
    setHidden(node, node.dataset.gbeCartGuardHidden === 'true');
    restoreAttribute(node, 'aria-hidden', node.dataset.gbeCartGuardAria);
    restoreAttribute(node, 'tabindex', node.dataset.gbeCartGuardTab);

    if (node.dataset.gbeCartGuardDisplay === '__none__') {
      setDisplay(node, '', '');
    } else {
      setDisplay(
        node,
        node.dataset.gbeCartGuardDisplay,
        node.dataset.gbeCartGuardPriority === '__none__' ? '' : node.dataset.gbeCartGuardPriority
      );
    }

    [
      'gbeCartGuardStored',
      'gbeCartGuardHidden',
      'gbeCartGuardAria',
      'gbeCartGuardTab',
      'gbeCartGuardDisplay',
      'gbeCartGuardPriority'
    ].forEach(function (key) {
      delete node.dataset[key];
    });
  }

  function hideCodMarkup(panel) {
    panel.querySelectorAll('[data-gbe-cod-option], [data-gbe-paycod-divider]').forEach(function (node) {
      setHidden(node, true);
      setAttribute(node, 'aria-hidden', 'true');
    });
  }

  function applyPolicy() {
    var panel = getPanel();
    if (!panel) return;

    var allowed = catalogAllowsCod(panel);

    document.querySelectorAll('#jcod-button, #jcod-dets').forEach(function (node) {
      suppress(node, !allowed);
    });

    if (!allowed) {
      setAttribute(panel, 'data-gbe-cart-guard-forced', 'true');
      setClass(panel, 'is-prepaid-only', true);
      setClass(panel, 'has-paycod', false);
      setAttribute(panel, 'data-gbe-payment-state', 'prepaid-only');
      hideCodMarkup(panel);
      return;
    }

    if (panel.dataset.gbeCartGuardForced === 'true') {
      delete panel.dataset.gbeCartGuardForced;
      setClass(panel, 'is-prepaid-only', false);
      setAttribute(panel, 'data-gbe-payment-state', 'checking-cod');
      hideCodMarkup(panel);
    }
  }

  function schedulePolicy() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      applyPolicy();
    });
  }

  function init() {
    if (!document.body.classList.contains('template-cart')) return;

    schedulePolicy();

    new MutationObserver(schedulePolicy).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class',
        'style',
        'hidden',
        'aria-hidden',
        'data-gbe-paycod-item-eligible',
        'data-gbe-catalog-cod-allowed'
      ]
    });

    document.addEventListener('cart-change', function () {
      window.setTimeout(schedulePolicy, 0);
      window.setTimeout(schedulePolicy, 150);
    });

    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(schedulePolicy, 0);
      window.setTimeout(schedulePolicy, 150);
    });

    [250, 800, 1600, 3000].forEach(function (delay) {
      window.setTimeout(schedulePolicy, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
